import { Empty, Spin, Flex, Button } from "antd";

import PlusIcon from "@/icons/PlusIcon";

import AttachedResourcesTable from "@/components/tables/AttachedResourcesTable";

const ObjectsTab = ({
  data,
  isAdmins,
  pending,
  readOnly = false,
  handleAddNew,
  handleAddNested,
  handleEdit,
  handleDelete,
}) => {
  const hasData = data.length > 0;
  const tableData = data.flatMap(({ type, objects }) =>
    objects?.length
      ? objects.map((obj) => ({
          ...obj,
          type,
          original: { type, objects },
          children:
            obj.nested_resources?.length > 0
              ? obj.nested_resources?.map((nested) => ({
                  ...nested,
                  original: { type, objects },
                  isNested: true, // полезно для рендеринга
                }))
              : null,
        }))
      : [{ type, children: null, original: { type, objects } }],
  );

  const addButton = !readOnly ? (
    <Button type="primary" icon={<PlusIcon />} onClick={handleAddNew}></Button>
  ) : null;

  return pending ? (
    <div className="spin" style={{ height: 100 }}>
      <Spin size="large" />
    </div>
  ) : hasData ? (
    <Flex vertical gap={15}>
      <Flex justify="flex-end" gap={15} align="center">
        {addButton}
      </Flex>

      <AttachedResourcesTable
        readOnly={readOnly}
        data={tableData}
        loading={pending}
        isAdmins={isAdmins}
        onAddNested={handleAddNested}
        onEditItem={handleEdit}
        onDeleteItem={handleDelete}
      />
    </Flex>
  ) : (
    <>
      <Flex justify="flex-end" gap={15} align="center">
        {addButton}
      </Flex>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    </>
  );
};

export default ObjectsTab;
